var GameStatus = /* @__PURE__ */ ((GameStatus2) => {
  GameStatus2["Active"] = "active";
  GameStatus2["Inactive"] = "inactive";
  return GameStatus2;
})(GameStatus || {});
var GameGatewayType = /* @__PURE__ */ ((GameGatewayType2) => {
  GameGatewayType2["REDIRECT"] = "redirect";
  GameGatewayType2["NATIVE"] = "native";
  return GameGatewayType2;
})(GameGatewayType || {});
var GameProviderType = /* @__PURE__ */ ((GameProviderType2) => {
  GameProviderType2["Amb"] = "amb";
  return GameProviderType2;
})(GameProviderType || {});
var GameProviderStatus = /* @__PURE__ */ ((GameProviderStatus2) => {
  GameProviderStatus2["Active"] = "active";
  GameProviderStatus2["Inactive"] = "inactive";
  return GameProviderStatus2;
})(GameProviderStatus || {});
var GameCategoryStatus = /* @__PURE__ */ ((GameCategoryStatus2) => {
  GameCategoryStatus2["Active"] = "active";
  GameCategoryStatus2["InActive"] = "inactive";
  return GameCategoryStatus2;
})(GameCategoryStatus || {});
export {
  GameCategoryStatus,
  GameGatewayType,
  GameProviderStatus,
  GameProviderType,
  GameStatus
};
